// import Beate from "../imgs/Beate.jpg";
import Beate from "../imgs/profil-bild2.png";
import "../css/global.scss"
import "../css/article.scss"
import { PageContent } from "./PageContent";

export const UeberMich = () => {
    return (
        <PageContent
            slug="ueber-mich"
            fallbackTitle="Beate Hoffmann"
            showHeroImage
            fallbackHeroImage={Beate}
            heroAlt="Beate Hoffmann"
            portableTextWrapClassName="about-me"
        >
            <div className="about-me" >
                <p className="about-me-intro">
                    Jeder Mensch trägt ein ganz einzigartiges Geschenk in sich – sich selbst. Es ist so wunderbar
                    und heilsam sich selbst zu entdecken, zuzulassen und dem Leben anzuvertrauen. Entwicklung und
                    Lernen hören nie auf und beides geht leichter, wenn man im Fluß ist. Heute sehe ich mein
                    Potential darin, gemeinsam mit Anderen zu SEIN, durch Tanz, in der Begegnung und durch gemeinsam
                    inspiriertes L(i)eben lernen.
                </p>

                <p className="about-me-contact">
                    Kontakt: <br /> 0177 43 47 677
                </p>

                <div className="center about-me-title">
                    <h3 >
                        Direktorin der Biodanza Schule Freiburg
                        <br />  Diplom Sozialarbeiterin
                    </h3>

                    <ul className="about-me-list">
                        <li>
                            Mitglied der IBFed International und IBFed Deutschland
                        </li>
                        <li>
                            Didakta Ausbildung 2018 - 2019
                        </li>
                        <li>
                            Gründung und Mitarbeit in der Keimzelle zur Gründung
                            einer Biodanza Lehrer Vereinigung 2020 - 2023
                        </li>
                        <li>
                            Biodanza mit Geflüchteten Frauen und Kindern : Kurse in Meckenheim, Deutschland
                        </li>
                        <li>
                            Biodanza mit Senioren: Kurse in Deidesheim, Deutschland
                        </li>
                        <li>
                            Vier Elemente Lehre in Biodanza
                        </li>
                        <li>
                            Vertiefungstagesworkshops, Frankreich und Deutschland
                        </li>
                        <li>
                            Biodanza Wochenendseminare für Erwachsene
                        </li>
                        <li>
                            Biodanza mit Kindern, Jugendlichen und Familien : Kurse in Revel und Albi, Frankreich
                        </li>
                        <li>
                            Biodanza Wochengruppen seit 2012, Frankreich und Deutschland
                        </li>
                        <li>
                            Lehrerausbildung bei Ricardo Toro in der Biodanza Schule Carcassonne Pays Cathare 2009 - 2014
                        </li>
                        <li>
                            14 Jahre Selbstständigkeit in Süd Frankreich
                        </li>
                        <li>
                            Freiberufliche Deutschtrainerin für Manager:innen in der beruflichen Weiterbildung, Luftfahrt
                            Toulouse, Frankreich
                        </li>
                        <li>
                            Ausbildung zur Tuina Praktikerin (TCM) an der Akademie Wang, Toulouse, Frankreich
                        </li>
                        <li>
                            erster Biodanza Wochenkurs als Teilnehmerin 2002
                        </li>
                        <li>
                            Aura Soma Farbberaterin, Frankreich
                        </li>
                        <li>
                            Reitpädagogin, Ferienprogramm, Wochenkurse, Ausritte, Anfängerunterricht, Deutschland
                        </li>
                        <li>
                            Diplom Sozialarbeiterin in Anstellung bei einem freien Träger der Jugendhilfe
                        </li>
                    </ul>
                </div>
            </div>
        </PageContent>
    )
}
